export enum CONDITION_TYPE {
    ANSWER = 'ANSWER',
    METADATA = 'METADATA',
}
